<template>
    <div class="productBoxCss">
        <div @click="jumpProductDetail(item)">
            <div class="itemImgBox">
                <div class="imgBox">
                    <img class="img" :src="item.image" :alt="item.productName">
                </div>
            </div>
            <div class="text">
                <div class="text_title ell-multi" :title="item.productName">
                {{ item.productName }}
                </div>
                <!-- <div class="text_label">
                    <span class="text_labelhour color_FF3333">小时达</span>
                    <span class="text_labelsubsidy color_01CB90">国家补贴</span>
                </div> -->
                <div class="priceBox">
                    <div class="flex_a_c">
                        <span class="color_FF3333 fontS_16">¥</span>
                        <span class="priceBox_price" style="color: #FF3B30;">{{ item.price }}</span>
                    </div>
                    <span class="priceBox_num fontSize_14" style="color: rgba(22,26,30,0.4);">已售{{ item.totalNumber }}件</span>
                    <!-- <span class="discount" v-if="item.originalPrice">¥{{item.originalPrice}}</span> -->
                </div>
            </div>
        </div>
        <div v-if="item.shopName && !isShowShop" class="flex_a_c fontSize_14 gap_3 color_97A3B7 lh_22" style="padding: 0 8px;" @click="toStore(item.shopId)">
            <div class="shopBox ell">
                {{ item.shopName }}
            </div>
            <i class="el-icon-arrow-right"></i>
        </div>
        </div>
</template>

<script>

import { funMixin } from '@/components/canvasShow/config/mixin' // 确保路径正确
import Cookie from 'js-cookie'

export default {
    name: 'productBox',
    mixins: [funMixin],
    props: ['item', 'isShowShop'],
    data () {
        return {
        }
    },
    mounted () {

    },
    methods: {
        // 跳转到店铺
        toStore (id) {
        if (Cookie.get('token')) {
            this.$router.push({
            path: '/store', query: { shopId: id }
            })
        } else {
            this.$store.commit('SHOW_LOGIN')
        }
        },
    }
}
</script>

<style lang="scss">
.productBoxCss {
        width: 254px;
        height: 390px;
      cursor: pointer;
      padding: 4px;
      &:hover {
          box-shadow: 0px 5px 12px 4px rgba(0,0,0,0.09), 0px 3px 6px 0px rgba(0,0,0,0.12), 0px 1px 2px -2px rgba(0,0,0,0.16);
          border: 1px solid #584DFF;
          border-radius: 4px;
      }

      .itemImgBox {
        .imgBox {
          width: 246px;
          height: 246px;

          .img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .text {
        padding: 8px;
        .text_title{
            font-size: 16px;
            text-align: left;
            margin-bottom: 8px;
            height: 48px;
            line-height: 24px;
            color: #181818;
        }
        .text_label{
            display: flex;
            gap: 6px;
            span{
                padding: 0 4px;
                font-size: 12px;
                line-height: 20px;
                display: inline-block;
            }
            .text_labelhour{
                background: rgba(255,51,51,0.1);
                border-radius: 2px 2px 2px 2px;
                border: 1px solid rgba(255,51,51,0.4);
            }
            .text_labelsubsidy{
                background: rgba(1,203,144,0.1);
                border-radius: 2px 2px 2px 2px;
                border: 1px solid rgba(1,203,144,0.4);
            }
            margin-bottom: 8px;
        }
      }
      .priceBox{
        display: flex;
        gap: 6px;
        align-items: center;
        .priceBox_price{
            font-size: 24px;
            color: #FF3333;
            line-height: 32px;
        }
      }
      .shopBox{
        max-width: 200px;
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/base/productBox.vue